export const darkTheme = {
  bg: "#050816",
  bgLight: "#0b1120",
  primary: "#8b5cf6",
  primary_alt: "#22d3ee",
  text_primary: "#e2e8f0",
  text_secondary: "#94a3b8",
  card: "#0f172a",
  card_light: "#111827",
  button: "#8b5cf6",
  white: "#ffffff",
  black: "#000000",
  accent: "#f472b6",
  success: "#22c55e",
  warning: "#fbbf24",
};

export const lightTheme = {
  bg: "#f8fafc",
  bgLight: "#eef2ff",
  primary: "#7c3aed",
  primary_alt: "#0ea5e9",
  text_primary: "#111827",
  text_secondary: "#475569",
  card: "#ffffff",
  card_light: "#f5f3ff",
  button: "#7c3aed",
  white: "#ffffff",
  black: "#000000",
  accent: "#ec4899",
  success: "#16a34a",
  warning: "#eab308",
};